module.exports = __webpack_public_path__ + "media/components/shared/images/TreePointIcon-3ac93719020a94b5aa6bfcc31b2ecb2d.png";